import styled from 'styled-components';

export const SpaAvailabilityWrapper = styled.div`
  padding: 10px 0;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

export const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: 20px;
  white-space: nowrap;
  align-items: center;
`;

export const DividerLine = styled.div`
  height: 1px;
  border-top: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
`;

export const DropdownWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
`;
